import { PermissionDenied } from '@/components/feedback/PermissionDenied';

export function ForbiddenPage() {
  return <PermissionDenied full />;
}
